import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';

import { useEditorStore } from 'containers/Tiptap/hooks/useEditorStore';

import { DocumentSettingsFormValues } from './types';

const SettingsDirtySync: React.FC = () => {
  const { dirty } = useFormikContext<DocumentSettingsFormValues>();
  const editorStore = useEditorStore();

  useEffect(() => {
    editorStore.setSettingsDirty(dirty);
  }, [dirty, editorStore]);

  useEffect(
    () => () => {
      editorStore.setSettingsDirty(false);
    },
    [editorStore]
  );

  return null;
};

export default SettingsDirtySync;
